export const GET_CURRENT_TECHNOLOGY = 'GET_CURRENT_TECHNOLOGY';


